// extracted by mini-css-extract-plugin
module.exports = {"root":"LootBoxes_root__smlsB","indicator":"LootBoxes_indicator__yazn4","label":"LootBoxes_label__8qfvG"};